import styled, { keyframes } from 'styled-components';

import { Image } from '@nw/shared/ui';

const scroll = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-100% - 24px));
  }
`;

export const StartupsCompaniesContainer = styled.div`
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  flex-direction: column;
  width: 100%;
  display: flex;
`;

export const StartupsMarquee = styled.div`
  gap: 24px;
  overflow: hidden;
  display: flex;
  user-select: none;
`;

export const StartupsMarqueeGroup = styled.div`
  gap: 24px;
  overflow: hidden;
  display: flex;
  flex-shrink: 0 !important;
  align-items: center;
  min-width: 100%;
  animation: 40s linear infinite ${scroll};
  white-space: nowrap;
`;

export const StartupsCompaniesImg = styled(Image)`
  height: 32px;
  flex-shrink: 0 !important;
`;
